import React from 'react';

import HelpButton from 'help/HelpButton';
import * as SchemaFieldConstants from 'schemas/fields/SchemaFieldConstants';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';

interface SchemaFieldValueErrorProps {
  errorLabel: string;
  schemaFieldRenderData: SchemaFieldConstants.SchemaFieldRenderData;
  message: string;
}

// Keep in sync with benchling/schemas/validation/base.py.
export const REQUIRED_FIELD_ERROR_LABEL = 'Required value';

/*
 * Rewrite some messages to be more useful to the user. Otherwise, use the message included.
 */
function getErrorMessageForMetadataTab(
  errorLabel: string,
  schemaFieldRenderData: SchemaFieldConstants.SchemaFieldRenderData,
  message: string
): string {
  if (
    schemaFieldRenderData.fieldType === SchemaFieldConstants.FIELD_TYPES.PART_LINK.type &&
    errorLabel === REQUIRED_FIELD_ERROR_LABEL
  ) {
    return `Highlight bases in the Sequence Map viewer, right-click, and select
    “Create new part... > ${schemaFieldRenderData.name}"`;
  }
  return message;
}

/**
 * Renders an error (e.g. Registry Validation errors in the Metadata tab).
 * Shows a red error label and a Help button, which shows a popover with the full error message on click.
 */
export default function SchemaFieldValueError(props: SchemaFieldValueErrorProps): JSX.Element {
  const {errorLabel, schemaFieldRenderData, message} = props;
  return (
    <div className="metadata-fieldError">
      <span className="u-danger-color">{errorLabel}</span>
      <HelpButton
        renderContent={() => getErrorMessageForMetadataTab(errorLabel, schemaFieldRenderData, message)}
        iconClassName="u-mini-spacing-left"
        placement={FloatingPlacement.BOTTOM}
      />
    </div>
  );
}
